import React from 'react';
import {Link} from 'react-router-dom';
import {Field, reduxForm} from 'redux-form';
import {validate} from 'validate-redux-form';
import {modalTextArea, renderField, render} from "../../Utils/renderField/renderField";
import {Notations} from "../../Utils/Notations";
import RadioGroup from 'antd/lib/radio/group';


const Form = (props) => {
    const {handleSubmit} = props;
    const view = window.location.href.includes("reporte");

    return (
        <form onSubmit={handleSubmit} className="d-flex flex-column">
            {!view ? <h3><strong>AGUDEZA VISUAL</strong></h3> : null}
            <div className="d-flex flex-column justify-content-center px-0 px-sm-2 px-md-3 px-lg-5">
                <table className="table-input">
                    <tbody>
                    <tr>
                        <th />
                        <th>
                            <span className='avl-azul'>AVL sc</span>
                        </th>
                        <th>
                            <span className='avl-azul'>AVL cc</span>
                        </th>
                        <th>
                            <span className='avl-verde'>AVC sc</span>
                        </th>
                        <th>
                            <span className='avl-verde'>AVC cc</span>
                        </th>
                        <th>
                            <span className='avl-rojo'>AVL ph</span>
                        </th>
                    </tr>
                    <tr>
                        <td>OD</td>
                        <td>
                            <Field name="od_avlsc" jaeger component={!view ? Notations : renderField} disabled={view} title={"AVL sc"} className="form-control"/>
                        </td>
                        <td>
                            <Field name="od_avlcc" jaeger component={!view ? Notations : renderField} disabled={view} title={"AVL cc"} className="form-control color-verde"/>
                        </td>
                        <td>
                            <Field name="od_avcsc" jaeger component={!view ? Notations : renderField} disabled={view} title={"AVC sc"} className="form-control"/>
                        </td>
                        <td>
                            <Field name="od_avccc" jaeger component={!view ? Notations : renderField} disabled={view} title={"AVC cc"} className="form-control"/>
                        </td>
                        <td>
                            <Field name="od_avlph" jaeger component={!view ? Notations : renderField} disabled={view} title={"AVL ph"} className="form-control"/>
                        </td>
                    </tr>
                    <tr>
                        <td>OS</td>
                        <td>
                            <Field name="os_avlsc" jaeger component={!view ? Notations : renderField} disabled={view} title={"AVL sc"} className="form-control"/>
                        </td>
                        <td>
                            <Field name="os_avlcc" jaeger component={!view ? Notations : renderField} disabled={view} title={"AVL cc"} className="form-control"/>
                        </td>
                        <td>
                            <Field name="os_avcsc" jaeger component={!view ? Notations : renderField} disabled={view} title={"AVC sc"} className="form-control"/>
                        </td>
                        <td>
                            <Field name="os_avccc" jaeger component={!view ? Notations : renderField} disabled={view} title={"AVC cc"} className="form-control"/>
                        </td>
                        <td>
                            <Field name="os_avlph" jaeger component={!view ? Notations : renderField} disabled={view} title={"AVL ph"} className="form-control"/>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div className='mt-4'>
                    <h4>
                        <strong>
                            TIPO DE OPTOTIPO
                        </strong>
                    </h4>
                </div>
                
                <div className='d-flex flex-row justify-content-center mb-3'>
                    <div className='d-flex flex-row justify-content-center'>
                        <label className="radio-inline mr-5 d-flex align-items-center flex-column">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 80 80"><path fill="#ed2f3c" d="M24 16v-2a2 2 0 0 0-2 2zm-2 48a2 2 0 1 0 4 0zm36-48a2 2 0 1 0-4 0zm-2 48v2a2 2 0 0 0 2-2zM25.067 16l1.698-1.057A2 2 0 0 0 25.067 14zm29.866 48l-1.698 1.057a2 2 0 0 0 1.698.943zM22 16v48h4V16zm32 0v48h4V16zm-30 2h1.067v-4H24zm-.631-.943l29.866 48l3.396-2.114l-29.866-48zM54.933 66H56v-4h-1.067z"/></svg>
                            <Field
                                name="optotype_type"
                                component={renderField}
                                type="radio"
                                value="1"
                                disabled={view}
                            />
                        </label>
                        <label className="radio-inline mr-5 d-flex align-items-center flex-column">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 80 80"><path fill="#ed2f3c" d="M30 14a2 2 0 1 0 0 4zm22 52a2 2 0 1 0 0-4zm-6.15-28.925l.895 1.789zM40 40l-.894-1.789zM30 18h10.875v-4H30zm-1 48h23v-4H29zm15.956-30.714l-5.85 2.925l1.788 3.578l5.85-2.925zM26 59.416V63h4v-3.584zM29 62a1 1 0 0 1 1 1h-4a3 3 0 0 0 3 3zm10.106-23.789A23.71 23.71 0 0 0 26 59.416h4a19.71 19.71 0 0 1 10.894-17.627zM50 27.125a9.12 9.12 0 0 1-5.044 8.16l1.789 3.579A13.13 13.13 0 0 0 54 27.124zM40.875 18A9.125 9.125 0 0 1 50 27.125h4C54 19.876 48.124 14 40.875 14z"/></svg>
                            <Field
                                name="optotype_type"
                                component={renderField}
                                type="radio"
                                value="2"
                                disabled={view}
                            />
                        </label>
                        <label className="radio-inline mr-5 d-flex align-items-center flex-column">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 80 80"><g fill="none" stroke="#ed2f3c" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M60 34v28H20V34"/><path d="M46 50V38H34v12z"/><path d="M67.5 40L40 18L12.5 40"/><path d="M55 30V20a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5.2"/></g></svg>
                            <Field
                                name="optotype_type"
                                component={renderField}
                                type="radio"
                                value="3"
                                disabled={view}
                            />
                        </label>
                        <label className="radio-inline d-flex align-items-center flex-column">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 80 80"><path fill="#ed2f3c" d="M56 18a2 2 0 1 0 0-4zm-32-2v-2a2 2 0 0 0-2 2zm32 50a2 2 0 1 0 0-4zm-32-2h-2a2 2 0 0 0 2 2zm0-26a2 2 0 1 0 0 4zm21.333 4a2 2 0 1 0 0-4zM56 14H24v4h32zm0 48H24v4h32zM22 16v.5h4V16zm0 47.5v.5h4v-.5zm0-47V40h4V16.5zM22 40v23.5h4V40zm2 2h21.333v-4H24z"/></svg>
                            <Field
                                name="optotype_type"
                                component={renderField}
                                type="radio"
                                value="4"
                                disabled={view}
                            />
                        </label>
                    </div>
                </div>

                <div className='d-flex flex-row justify-content-center'>
                    <div className="mb-md-4 d-flex justify-content-between flex-column flex-sm-row align-items-stretch align-items-sm-center mt-4 w-50">
                        <div className="m-2 d-flex flex-column w-100">
                            <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                <label htmlFor="notes">Notas</label>
                            </div>
                            <div className='d-flex flex-row'>
                                <label className="radio-inline mr-3 d-flex align-items-center">
                                    OD&nbsp;
                                    <Field
                                        name="type"
                                        component={renderField}
                                        type="radio"
                                        value={"1"}
                                        disabled={view}
                                    />
                                </label>
                                <label className="radio-inline mr-3 d-flex align-items-center">
                                    OS&nbsp;
                                    <Field
                                        name="type"
                                        component={renderField}
                                        type="radio"
                                        value={"2"}
                                        disabled={view}
                                    />
                                </label>
                                <label className="radio-inline mr-3 d-flex align-items-center">
                                    OU&nbsp;
                                    <Field
                                        name="type"
                                        component={renderField}
                                        type="radio"
                                        value={"3"}
                                        disabled={view}
                                    />
                                </label>
                            </div>
                            <div className="d-flex flex-row w-100">
                                <div className="d-flex flex-row w-75">
                                <Field
                                    name="notes"
                                    component={modalTextArea}
                                    className="annotations"
                                    disabled={view}
                                />
                                </div>
                                <div className='d-flex flex-row w-25 ml-3'>
                                    <button
                                        type="button"
                                        className='btn btn-danger'
                                        onClick={()=>{props.change('notes', 'DIFERIDO');}}
                                    >DIFERIDO</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
};

const CrearForm = reduxForm({
    // a unique name for the form
    form: 'VisualAcuity',
    validate: (data) => {
        return validate(data, {
        });
    },
})(Form);

export default CrearForm;
